import React, { useEffect, useState } from 'react'
import {
    Box,
    Checkbox,
    CircularProgress,
    Fade,
    FormControl,
    FormControlLabel,
    MenuItem,
    Modal,
    Select,
    Stack,
    Tab, Tabs,
    styled,
    TextField,
    Typography,
    Divider
} from "@mui/material";
import disableIcon from "../../../assets/images/icon/disableIcon.svg"
import deleteIcon from "../../../assets/images/icon/delete-icon.svg"
import closeIcon from "../../../assets/images/close.svg"
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import LicenseModalTabOne from './licenseDetailModalTabs/LicenseModalTabOne';
import LicenseModalTabTwo from './licenseDetailModalTabs/LicenseModalTabTwo';
import LicenseModalTabThree from './licenseDetailModalTabs/LicenseModalTabThree';
import { getMethod, putMethod } from '../../../services/apiService';
import { getUserId } from '../../../helper/helper';
interface LicenseDetailModalProps {
    openModal: boolean; // The state that controls modal visibility
    handleCloseModal: () => void; // Function to close the modal
    selectedRow:any;
    setOpenModal:any
}
const LicenseDetailModal: React.FC<LicenseDetailModalProps> = ({
    openModal,
    setOpenModal,
    handleCloseModal,
    selectedRow,
}) => {

    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event: any, newValue: any) => {
        setActiveTab(newValue);
    }

    const styleModal = {

        position: "absolute" as "absolute",
        top: "40%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        minWidth: "900px",
        minHeight: "650px",
        marginTop: "80px",
        backgroundColor: "#03171F",
        border: "1px solid #5A5F60",
        borderRadius: "32px",
        padding: "32px",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column"
    };

    const [licenseDetailsAll, setLicenseDetailsAll] = useState([])
    const disableLicense =async (key:any)=>{
        let payload ={
            "key": key,
            "data": {
                "status": 1
            }
        }

       let response = await putMethod("partner/license",payload) 
       setOpenModal(false)
    }

    useEffect(() => {
        fetchLicenseDetail();
    }, []);
    
    let user = getUserId()

    
    const fetchLicenseDetail = async () => {
        const respo = await getMethod(`partner/license/${user}/${selectedRow.license.key}`);
        setLicenseDetailsAll(respo.data.result[0])
    }


    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={openModal}
                onClose={handleCloseModal}
                closeAfterTransition
                // BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
                className="customMuiModal"
                sx={{ overflowY: "auto" }}
            >
                <Fade in={openModal}>
                    <Box sx={styleModal}>

                        <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Typography
                                sx={{ color: "#E2E3E3", fontWeight: 500, fontSize: "20px" }}
                            >
                                License Key:{selectedRow.license.key}
                            </Typography>
                            <img
                                src={closeIcon}
                                alt="close icon"
                                onClick={handleCloseModal}
                                className="icon"
                                style={{ cursor: "pointer" }}
                            />
                        </Stack>
                        <Box sx={{ flexGrow: 1, mt: 2 }}>
                            <TabContext value={String(activeTab)}>
                        <Box sx={{ borderBottom: 1, borderColor: '#313838', }}>

                                <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary"
                                    textColor="inherit"
                                    variant="fullWidth">
                                    <Tab label="License Details" value={0} style={{textTransform: "none"}} />
                                    <Tab label="Site / Device" value={1} style={{textTransform: "none"}} />
                                    <Tab label="Feature" value={2} style={{textTransform: "none"}} />
                                </Tabs>
                                </Box>
                                <TabPanel value="0"  >
                                    <LicenseModalTabOne licenseDetailsAll={licenseDetailsAll} selectedRow={selectedRow} />
                                </TabPanel>
                                <TabPanel value="1"  >
                                    <LicenseModalTabTwo licenseDetailsAll={licenseDetailsAll} />
                                </TabPanel>
                                <TabPanel value="2"  >

                                    <LicenseModalTabThree  licenseDetailsAll={licenseDetailsAll} />

                                </TabPanel>
                            </TabContext>
                        </Box>

                        <Divider sx={{ borderColor: "#313838", marginY: 2 }} />
                        <Box
                            sx={{
                                display:"flex",
                                mt: 3,
                                alignSelf: "flex-end"
                                //   textAlign: "center",
                            }}
                        >
                            <Stack
                                display="flex"
                                flexDirection="row"
                                border=  '1px solid #0B4A62'
                                borderRadius= '30px'
                                alignItems="center"
                                gap="4px"
                                marginRight="10px"
                                fontSize={"14px"}
                                style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    color: "#17B2EB",
                                }}
                            onClick={() => disableLicense(selectedRow.license.key)}
                            >
                                <img src={disableIcon} alt="delete Icon" />
                                Disable License
                            </Stack>
                            {/* <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            gap="4px"
                            fontSize={"14px"}
                            style={{
                                padding: "8px 12px",
                                cursor: "pointer",
                                color: "#17B2EB",
                            }}
                            // onClick={() => handleDelete()}
                        >
                            <img src={deleteIcon} alt="delete Icon" />
                            Delete
                        </Stack> */}

                        </Box>
                    </Box>


                </Fade>


            </Modal>
        </>
    )
}

export default LicenseDetailModal